
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12.356","r":"12","fill":"#F4F4F4"}}),_c('path',{attrs:{"d":"M12 18.84l-.913-.913C7.696 14.932 5.48 12.914 5.48 10.44c0-2.019 1.565-3.582 3.586-3.582 1.11 0 2.218.521 2.935 1.368a3.922 3.922 0 012.935-1.368c2.022 0 3.587 1.563 3.587 3.582 0 2.474-2.217 4.492-5.609 7.487L12 18.84z","fill":"#B8CDD7"}})])
          )
        }
      }
    